import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { pathname, forwardUrlParams, is8DataApp } from '../utils';

export default function SignupRoute() {
  const onboardingv2Url = is8DataApp()
    ? pathname.preLogin.getStarted.accountCreation.url
    : pathname.preLogin.getStarted.platform.url;

  return (
    <Route exact path={pathname.preLogin.signup.url}>
      <Redirect
        to={{ pathname: onboardingv2Url, search: forwardUrlParams() }}
      />
    </Route>
  );
}
